<script lang="ts" setup>
	import { ref, provide, onMounted, computed } from 'vue';
	import { useRoute, useRouter } from "vue-router"
	import { getAuth, signOut } from "firebase/auth"
	import Notifications from '@/components/block/Notifications.vue';
	import { useTeamStore } from '@/store/team.store';
	import { useSubscribersStore } from '@/store/subscribers.store';
	import { useAuthStore } from '@/store/auth.store';
	import { useMarketingStore } from '@/store/marketing.store';

	const router = useRouter();
	const route = useRoute();
	const teamStore = useTeamStore();
	const subscribersStore = useSubscribersStore();
	const authStore = useAuthStore();
	const marketingStore = useMarketingStore();
	const notificationsOpen = ref(false);

	const handleSignOut = () => {
		signOut(getAuth()).then(() => {
			router.push('/')
		})
	}

	const userId = computed<string>(() => (String(route.params.userId || '') || authStore.user.id || '-'));
	const subId = computed<string>(() => (String(route.params.subscriberId || '')  || '-'));
	const companyName = computed<string>(() => (teamStore.groupsMap.get(String(route.params.groupId || authStore.user.group || '-'))?.name) || '-');
	const userName = computed<string>(() => (userId.value && teamStore.usersMap.get(userId.value)?.name) || '-');
	const subName = computed<string>(() => (subId.value && subscribersStore.subscribersMap.get(subId.value)?.name) || '-');
	const subLastName = computed<string>(() => (subId.value && subscribersStore.subscribersMap.get(subId.value)?.lastName) || '-');
	const linkName = computed<string>(() => (marketingStore.signUpLinksMap.get(+(route.params.linkId || 0))?.name) || '-');


	//---------------------------Notifications--------------------------------
	const closeNotifications = () =>{
		setTimeout(() => {
			notificationsOpen.value = false
		}, 1000)
		const notifications  = document.querySelector('.notifications')
		notifications?.classList.remove('notifications--active')
	}

	const openNotifications = () =>{
		notificationsOpen.value = true
		setTimeout(() => {
			const notifications  = document.querySelector('.notifications')
			notifications?.classList.add('notifications--active')
		}, 100)
	}

	const props = defineProps<{
		namePage: string,
		descPage: string,
		backPage: string,
	}>();

	provide('notifications', {
		closeNotifications,
		openNotifications,
	});

	const desc = computed<string>(() => props.descPage.replace('[Company Name]', companyName.value).replace('[Subscriber name]', subName.value).replace('[Subscriber Last Name]', subLastName.value).trim());
	const name = computed<string>(() => props.namePage.replace('[Company Name]', companyName.value).replace('[User name]', userName.value).replace('[Link name]', linkName.value));

	const goBack = () => {
		router.back();
	};

	const isUserPage = computed(() => {
		return route.path === '/user' || (route.path.startsWith('/users/') && route.params.userId);
	});

</script>
userName
<template>
	<div class="topbar">
		<div class="topbar__title">
			<router-link 
				v-if="backPage && !isUserPage" 
				:to="backPage" 
				:class="{ 'back--hidden': isUserPage }" 
				class="back"
			>
				<span class="material-symbols-outlined">arrow_back</span>
			</router-link>

			<span 
				v-if="isUserPage" 
				@click="goBack" 
				class="topbar__user-back material-symbols-outlined"
			>
				arrow_back
			</span>
			<div>
				<h3 v-if="namePage">{{ name }}</h3>
				<p v-if="desc">{{ desc }}</p>
			</div>

		</div>

		<div class="topbar__wrap">
			<!-- <div class="topbar__search">
				<img src="/img/topbar__search.svg" alt="">
				<input type="text" placeholder="Search anything...">
			</div> -->
			<!-- <div class="topbar__bell" @click="openNotifications">
				<span class="material-symbols-outlined">notifications</span>
				<span class="topbar__bell_number"></span>
			</div> -->
			<router-link to="/user" :class="{ 'topbar__user--active': route.path === '/user' }" class="topbar__user">
				<img v-if="teamStore.usersMap.get(userId)?.img" :src="teamStore.usersMap.get(userId)?.img" alt="" class="topbar__user-img">
				<span v-else class="material-symbols-outlined">person</span>
			</router-link>
			
			<button class="topbar__logout" @click="handleSignOut">
				<span class="material-symbols-outlined">logout</span>
			</button>
		</div>

	</div>

	<Notifications/>

</template>


<style lang="scss" scoped>
	.topbar {
		position: fixed;
		top: 0;
		left: 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100vw;
		padding: 15px 30px 15px 100px;
		background: #fff;
		box-shadow: 29px 7px 45px rgba(0, 0, 0, 0.05);
		z-index: 100;
		transition: all .6s;
	}
	.topbar--active {
		padding-left: 270px;
	}
	.topbar__user-back{
		cursor: pointer;
	}
	.topbar__title {
		display: flex;
		align-items: start;
		gap: 10px;
	}
	.topbar__title h3 {
		font-size: 24px;
		font-weight: 700;
		margin-bottom: 5px;
	}
	.topbar__title p {
		font-size: 12px;
		font-weight: 500;
		color: #64748B;
	}
	.topbar__title a {
		color: #000;
	}
	.topbar__arrow {
		margin-right: 15px;
		margin-top: 7px;
		cursor: pointer;
	}
	.topbar__wrap {
		display: flex;
		align-items: center;
		gap: 30px;
	}
	.topbar__search {
		position: relative;
	}
	.topbar__search img {
		position: absolute;
		left: 20px;
		top: 15px;
	}
	.topbar__search input {
		height: 45px;
		width: 275px;
		padding: 15px 20px 15px 50px;
		border-radius: 8px;
		color: #94A3B8;
		border: 1px solid #93C5FD;
		outline: none;
		font-size: 14px;
	}
	.topbar__bell {
		position: relative;
		cursor: pointer;
	}
	.topbar__bell:hover {
		color: #2563EB;
	}
	.topbar__bell span {
		transition: all .6s;
	}
	.topbar__bell_number {
		position: absolute;
		top: 4px;
		left: 13px;
		width: 8px;
		height: 8px;
		background: #2563EB;
		border: 1px solid #fff;
		border-radius: 50px;
	}
	.topbar__user {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		background: #93C5FD;
		color: #fff;
		border-radius: 50px;
		cursor: pointer;
		overflow: hidden;
		transition: all .3s;
	}
	.topbar__user--active{
		border: 2px solid #2563EB;
	}
	.topbar__user:hover {
		box-shadow: 0 0 8px rgba(0, 0, 0, .2);
	}
	.topbar__user-img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
	.topbar__logout {
		background: none;
		border: none;
		cursor: pointer;
	}
	.topbar__logout:hover {
		color: #2563EB;
	}

	.back {
		margin-top: 7px;
	}
	.back:hover {
		color: #2563EB;
	}
	.back--hidden {
		display: none;
	}
	.topbar__user-back{
		margin-top: 7px;
	}

</style>